import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
@Component({
    moduleId: module.id,
    selector: 'confirmation-account',
    templateUrl: 'confirmation-account.component.html',
    styleUrls: ['confirmation-account.component.scss']
})
export class ConfirmationAccountComponent {
    confirme=false;
    aleardyConfirmed=false;
    error=false;
    loading=true;
    idUser;
    key;
    constructor(public route: ActivatedRoute,private webuser:WebSiteUsersService){
        this.route.params.subscribe(params => {
            this.key=params['key'];
            this.idUser = params['user'];
            this.webuser.confirme(this.idUser,this.key).subscribe(
                (data:any)=>{
                    this.loading=false;
                    if(data.code == 1){
                        this.error=false;
                        this.confirme=true;
                        this.aleardyConfirmed=false;
                    }else{
                        this.error=false;
                        this.confirme=false;
                        this.aleardyConfirmed=true;
                    }
                   
                },
                (err)=>{
                    this.loading=false;
                    this.error=true;
                }
            )
        })
    }
    ngOnInit(){
    }
}
